import CreateTool from '@/vue3/components/geo-record-tools/CreateTool.vue';
import FeatureAreaTool from '@/vue3/components/geo-record-tools/FeatureAreaTool.vue';
import MeasureTool from '@/vue3/components/geo-record-tools/MeasureTool.vue';
import DuplicateTool from '@/vue3/components/geo-record-tools/DuplicateTool.vue';
import SmoothTool from '@/vue3/components/geo-record-tools/SmoothTool.vue';
import SelectTool from '@/vue3/components/geo-record-tools/SelectTool.vue';

export default {
    CreateTool,
    FeatureAreaTool,
    MeasureTool,
    DuplicateTool,
    SmoothTool,
    SelectTool,
};
